import { NpcChatDataOld } from "../loaders/con";
import { GDM } from "../helpers/datamanager";

const triggerNamesByConversationPath = new Map<string, string[]>();

function extractTriggerNames(luaSource: string): string[] {
  const names = new Set<string>();
  const pattern = /QF_doQuestTrigger\(\s*["']([^"']+)["']/g;
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(luaSource)) !== null) {
    names.add(match[1]);
  }
  return Array.from(names);
}

function getTriggerNamesForConversation(conversationPath: string): Promise<string[]> {
  const cached = triggerNamesByConversationPath.get(conversationPath);
  if (cached) {
    return Promise.resolve(cached);
  }
  return NpcChatDataOld.loadSource(conversationPath)
    .then((data: any) => {
      const names = extractTriggerNames(data.luaData || "");
      triggerNamesByConversationPath.set(conversationPath, names);
      return names;
    })
    .catch((_error: any) => {
      // Conversation asset not found or failed to load; fail open with empty triggers
      triggerNamesByConversationPath.set(conversationPath, []);
      return [];
    });
}

export function computeNpcHasAvailableQuest(npc: any): Promise<boolean> {
  const dialogId = npc.dialogIdx || npc.eventIdx;
  if (!dialogId) {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    GDM.get("list_event", "quest_scripts", (eventList: any, questScripts: any) => {
      const eventData = eventList.row(dialogId);
      const conversationPath = eventData && eventData[3];
      if (!conversationPath) {
        resolve(false);
        return;
      }

      getTriggerNamesForConversation(conversationPath).then((triggerNames) => {
        resolve(triggerNames.some((name) => questScripts.canStartQuest(name)));
      });
    });
  });
}

export function _clearConversationTriggerCache(): void {
  triggerNamesByConversationPath.clear();
}
